<div class="row" *ngIf="form as form" [formGroup]="form">
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"regon" as controlName'>
      <label [for]='controlName'>
        REGON *
      </label>
      <input
        [id]='controlName'
        [formControlName]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        placeholder='Wpisz tu REGON'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"name" as controlName'>
      <label [for]='controlName'>
        Nazwa *
      </label>
      <input
        [id]='controlName'
        [formControlName]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        placeholder='Wpisz tu nazwę'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
</div>
